"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTimeFromDate = exports.getUTCDate = exports.getLocalDate = exports.displayTime = exports.displayDate = exports.dateToMMDDYYYY = void 0;

var dateToMMDDYYYY = function dateToMMDDYYYY(date) {
  var year = date.getFullYear();
  var month = (date.getMonth() + 1).toString().padStart(2, "0");
  var day = date.getDate().toString().padStart(2, "0");
  return "".concat(month, "/").concat(day, "/").concat(year);
};

exports.dateToMMDDYYYY = dateToMMDDYYYY;

function getCurrentTimezoneName() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function getUTCOffset() {
  return new Date().getTimezoneOffset();
}

function minusMinutes(date, minutes) {
  return new Date(date.getTime() - minutes * 60000);
}

function convertUTCToLocal(utcDate, options) {
  var date = new Date(utcDate).toLocaleString("en-US", Object.assign({
    timeZone: getCurrentTimezoneName()
  }, options));
  return date;
} // Arguments, date - should be string or Javascript date object, ex: 2021-07-16 or new Date()
// Returns, Local date, ex: Jul 16, 2021


var displayDate = function displayDate(date) {
  if (typeof date == "string") date = date.split("-").join("/");
  return convertUTCToLocal(date, {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
};

exports.displayDate = displayDate; // Arguments ,Time - should be string or Javascript Date object, ex: 20:53:5:226 or new Date()
// Returns, Local Time, ex: 3:53 PM

var displayTime = function displayTime(time) {
  var timeObj;

  if (typeof time == "string") {
    timeObj = time;
  } else {
    timeObj = time.getUTCHours() + ":" + time.getUTCMinutes() + ":" + time.getUTCSeconds() + ":" + time.getUTCMilliseconds();
  }

  var _timeObj$split = timeObj.split(":"),
      _timeObj$split2 = _slicedToArray(_timeObj$split, 3),
      hour = _timeObj$split2[0],
      minute = _timeObj$split2[1],
      second = _timeObj$split2[2];

  var currentTime = new Date(0, 0, 0, +hour, +minute, +second);
  var utcOffset = getUTCOffset();
  var localTime = minusMinutes(currentTime, utcOffset);
  return convertUTCToLocal(localTime.toISOString(), {
    hour: "numeric",
    minute: "numeric",
    hour12: true
  });
};

exports.displayTime = displayTime; // Arguments, date - should be Date, ex: Fri, 16 Jul 2021 20:53:05 GMT
// Returns, Local Date - ex: Fri Jul 16 2021 15:53:05 GMT-0500 (Central Daylight Time)

var getLocalDate = function getLocalDate(date) {
  return new Date(convertUTCToLocal(date, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }));
};

exports.getLocalDate = getLocalDate; // Arguments, localDate - should be string, ex: Fri Jul 16 2021 15:53:05 GMT-0500 (Central Daylight Time)
// Returns, UTC Date, ex: Fri, 16 Jul 2021 20:53:05 GMT

var getUTCDate = function getUTCDate(localDate) {
  var date = new Date();
  var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  return new Date(now_utc);
};

exports.getUTCDate = getUTCDate;

var removeTimeFromDate = function removeTimeFromDate(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

exports.removeTimeFromDate = removeTimeFromDate;
var DateTimeUtilities = {
  dateToMMDDYYYY: exports.dateToMMDDYYYY,
  getCurrentTimezoneName: getCurrentTimezoneName,
  getUTCOffset: getUTCOffset,
  minusMinutes: minusMinutes,
  convertUTCToLocal: convertUTCToLocal,
  displayDate: exports.displayDate,
  displayTime: exports.displayTime,
  getLocalDate: exports.getLocalDate,
  getUTCDate: exports.getUTCDate,
  removeTimeFromDate: exports.removeTimeFromDate
};
exports.default = DateTimeUtilities;